import styled from "@emotion/styled/macro";
import { css } from "@emotion/react";
import { Skeleton, SvgIcon, tokens } from "@sunrun/experience-ui-components";
import { Card, CardHeader } from "../Card";

const buttonStyles = css`
  background: none;
  border: none;
  cursor: pointer;
  :hover {
    background-color: ${tokens.INFO_90};
  }
  :active {
    background-color: ${tokens.INFO_70};
  }
`;

const SlotsPagerControlLeft = styled.button`
  ${buttonStyles}
  position: absolute;
  left: 0;
`;

const SlotsPagerControlRight = styled.button`
  ${buttonStyles}
  position: absolute;
  right: 0;
`;

const SlotsHeaderText = styled.span`
  text-align: center;
  user-select: none;
`;

const SlotsHeader = styled(CardHeader)`
  display: flex;
  position: relative;
  & > * {
    flex: 1 1 0;
  }
`;

const SlotsGrid = styled.div`
  display: flex;
  flex-direction: row;
  gap: 16px;
  & > * {
    flex: 1 1 0;
  }
`;

const Column = styled.div`
  display: flex;
  gap: 16px;
  flex-direction: column;
`;

const SlotSkeleton = styled(Skeleton)`
  height: 3em;
`;

const SlotCheckmark = styled(SvgIcon)`
  height: 1.5em;
  vertical-align: bottom;
  position: absolute;
  right: 16px;
  svg,
  path {
    fill: ${tokens.SUCCESS_60};
  }
`;

const SlotTimeText = styled.span`
  user-select: none;
`;

const Slot = styled(Card)`
  border: 1px solid ${tokens.TINTS_OFF_WHITE_40};
  padding: 1em 2.5em;
  text-align: center;
  position: relative;
  cursor: pointer;
  &[aria-selected="true"] {
    background-color: ${tokens.HEROBLUE_90};
    border: 1px solid ${tokens.TINTS_CHARGE_BLUE_40};
    color: black;
  }
  :hover {
    color: ${tokens.WHITE};
    background-color: ${tokens.BRAND_MEDIUM_BLUE};
    border: 1px solid ${tokens.TINTS_OFF_WHITE_40};
  }
`;

const SlotsErrorWrapper = styled.div`
  padding: 2em 2em;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
`;

const SlotsUnavailableWrapper = styled.div`
  padding: 2em 2em;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const SlotsUnavailableP = styled.p`
  text-align: center;
  text-wrap: balance;
`;

const InlineEmptySlotsWrapper = styled.div`
  padding: 2em 2em;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const SlotsCtaWrapper = styled.div`
  padding: 2em 2em;
  min-height: 9em;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

const InlineEmptySlotsMessage = styled.p`
  margin: 0;
  text-align: center;
  text-wrap: balance;
`;

const ConfirmationCard = styled.div<{ $maxWidth?: string }>`
  max-width: ${({ $maxWidth }) => $maxWidth ?? "340px"};
`;

const ScheduledAppointmentCTA = styled.div`
  display: flex;
  gap: 24px;
`;

const ScheduledInfoPillWrapper = styled.div`
  margin-bottom: 12px;
`;

/** Layout overrides for Contact Team modal (experience-ui Modal body + footer). */
const SlotsUnavailableModalLayout = styled.div`
  .modal-wrapper.checkout-slots-unavailable-modal .modal-content-container {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .modal-wrapper.checkout-slots-unavailable-modal [data-testid="modal-footer"] {
    justify-content: flex-start !important;
    align-items: flex-start;
  }
`;

export {
  Column,
  ConfirmationCard,
  ScheduledAppointmentCTA,
  ScheduledInfoPillWrapper,
  Slot,
  SlotCheckmark,
  SlotSkeleton,
  SlotTimeText,
  SlotsErrorWrapper,
  SlotsGrid,
  SlotsHeader,
  SlotsHeaderText,
  SlotsPagerControlLeft,
  SlotsPagerControlRight,
  SlotsUnavailableModalLayout,
  SlotsUnavailableP,
  SlotsUnavailableWrapper,
  InlineEmptySlotsWrapper,
  InlineEmptySlotsMessage,
  SlotsCtaWrapper,
};
